import React, { useState } from "react"
import {
    TextField,
    Button,
    Container,
    Typography,
    Box,
    Grid,
    CircularProgress,
    Alert,
} from "@mui/material"
import JSEncrypt from "jsencrypt"
import sha256 from "js-sha256"
import { useNavigate } from "react-router-dom"
import { AuthenticationApi } from "../../../api/Authentication/LoginApi"

const Login: React.FC = () => {
    const [username, setUsername] = useState<string>("receptionadmin@zypp.app")
    const [password, setPassword] = useState<string>("123456")
    const [loginError, setLoginError] = useState<string | null>(null)
    const [loader, setLoader] = useState<boolean>(false)
    const navigate = useNavigate()

    const hexToBytes = (hex: string) => {
        const bytes: number[] = []
        for (let i = 0; i < hex.length; i += 2) {
            bytes.push(parseInt(hex.substr(i, 2), 16))
        }
        return bytes
    }

    const handleLogin = async () => {
        setLoader(true)
        setLoginError(null)
        try {
            const timestamp = String(Date.now())
            const hash = sha256.sha256(password + timestamp)
            const hashBytes = hexToBytes(hash)
            const hashBase64 = btoa(String.fromCharCode(...hashBytes))
            const data = `${password}:${timestamp}:${hashBase64}`
            const encrypt = new JSEncrypt()
            encrypt.setPublicKey(
                "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAg79k2m8PlGNIyJum2uzGqnhdjNqc90SF5FwoOlU7I6Hy6xh36K2qzw1Q5wLcfM+KojFy0xLzKf/u03Wm9S/SmbwvzlXaCq5uYEtVqJBxCz3Y+ZyTRlWyWDJki+OvGYqGbw1EmmKFt2SaOjsE/e+lo6KQpFZwGuaJ1ZKQjCbKRdmkOUAWIjK51a3r8kTnq7XIMf9iXaHX5qvTS/BMcRrXTQ5/JGeuy9OCaJ0S7YrSINZymd0puA0IH87QxDmnUoq+pJwo8l67MFwK7rLyCDSRGwdVY4kLQw8T25k53eoH6+ZUMLydkR4X/ryXYERIw/OwPWpoioHARKzyA/ARA2jkTQIDAQAB"
            )

            const encryptedData = encrypt.encrypt(data)
            if (!encryptedData)
                throw new Error("Encryption failed. Invalid data.")

            const response =
                await AuthenticationApi.api.onlineUserAuthentication(
                    username,
                    encryptedData
                )

            setLoader(false)
            if (response.data && response.data.token) {
                localStorage.setItem("token", response.data.token)
                navigate("/home")
            } else {
                setLoginError(response.message || "Access Denied")
            }
        } catch (error) {
            console.error("Login error:", error)
            setLoader(false)
            setLoginError("Invalid Credentials or Network Error")
        }
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        handleLogin()
    }

    return (
        <form onSubmit={handleSubmit}>
            <Container maxWidth={false} disableGutters>
                <Grid container spacing={0} style={{ minHeight: "80vh" }}>
                  
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            display: { xs: "none", md: "block" },
                            height: "100vh",
                            backgroundImage: "url('/assets/Dark-Green.svg')",
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                        }}
                    />
           
                    <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "80vh",
                            padding: { xs: 2, md: 4 },
                        }}
                    >
                        {/* Logo */}
                        <Box
                            component="img"
                            src="/zypp-logo.svg"
                            alt="Logo"
                            sx={{
                                width: { xs: "60px", md: "80px" },
                                mb: 2,
                            }}
                        />
                        {/* Login Form */}
                        <Box
                            sx={{
                                width: "100%",
                                maxWidth: 400,
                            }}
                        >
                            <Typography
                                variant="h5"
                                component="h1"
                                textAlign="center"
                                mb={3}
                            >
                                Login
                            </Typography>
                            <TextField
                                label="Username"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                required
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                            <TextField
                                label="Password"
                                type="password"
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            {loader ? (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    mt={2}
                                >
                                    <CircularProgress />
                                </Box>
                            ) : (
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        mt: 2,
                                        bgcolor: "#1FCD5B",
                                        "&:hover": { bgcolor: "#17a748" },
                                    }}
                                >
                                    Login
                                </Button>
                            )}
                            {loginError && (
                                <Alert
                                    severity="error"
                                    sx={{ mt: 2 }}
                                >
                                    {loginError}
                                </Alert>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </form>
    )
}

export default Login
